import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ClockIcon } from 'lucide-react';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState(10800);
  const [country, setCountry] = useState<string | null>(null);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
      if (data && data.country_code) {
        setCountry(data.country_code);
      } else {
        setCountry('US'); // Default to non-AR if detection fails
      }
    }).catch(() => {
      setCountry('US'); // Default to non-AR on error
    });
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const isAR = country === 'AR';
  return <section id="pricing" className="py-10 md:py-14 px-4 bg-[#F5F0FF]" data-id="element-85" data-mp="1hpy6vr1vcumh">
      <div className="max-w-7xl mx-auto" data-id="element-86" data-mp="1hnv92kuh5x77">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-10" data-id="element-87" data-mp="1cqbwrqhc7uhw">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D3F]" data-id="element-88" data-mp="25er73zpixomw">
            Elegí el pack que mejor se adapte a vos
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-stretch justify-center max-w-6xl mx-auto" data-id="element-89" data-mp="1vg1pm81ji676">
          {/* Mega Pack (Mobile: Order 1, Desktop: Order 3) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="order-1 md:order-3 w-full md:w-1/3 bg-white rounded-3xl p-6 sm:p-8 shadow-xl border-4 border-[#FF6B8A] relative flex flex-col z-10 md:scale-105" data-id="element-90" data-mp="k2g2esf8qeoa">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#FFD166] text-[#2D2D3F] font-black px-4 py-1.5 rounded-full shadow-md text-sm sm:text-base whitespace-nowrap" data-id="element-91" data-mp="7k3n7cixk5q7">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="mb-4 flex justify-center" data-id="element-92" data-mp="3uv37e7ovx3xf">
              <img src="https://cdn.magicpatterns.com/uploads/ovxazyqe6TbNyon72GLS97/MEGA_PACK.png" alt="Mega Pack Disney" className="w-full max-w-[200px] object-contain drop-shadow-md" data-id="element-93" data-mp="3iig67t2ulnx" />
            </div>
            <div className="mb-5 text-center md:text-left" data-id="element-94" data-mp="3pws126xstbjy">
              <h3 className="text-2xl sm:text-3xl font-extrabold text-[#2D2D3F] mb-1" data-id="element-95" data-mp="3pv8ho7guikdy">
                Mega Pack Disney
              </h3>
              <p className="text-[#6B7280] font-medium text-sm sm:text-base" data-id="element-96" data-mp="3fzncy1ke760i">
                10 libros coloreables Disney + 3 bonus extra
              </p>
            </div>
            <div className="mb-6 flex-grow" data-id="element-97" data-mp="2sc0azlvcotdn">
              <div className="bg-[#FFF5F7] border border-[#FFD1D9] rounded-xl p-3 mb-4" data-id="element-98" data-mp="2sdbl03fe2xd7">
                <p className="text-sm sm:text-base font-bold text-[#FF6B8A] flex items-start gap-2" data-id="element-99" data-mp="36cufvuj6wc7k">
                  <span data-id="element-100" data-mp="31bx1zu57q4bv">🎁</span>
                  <span data-id="element-101" data-mp="31et1vo0mf32y">+ NUEVO REGALO<br data-id="element-102" data-mp="3g9z5y5g5ortn" /><span className="text-[#2D2D3F] font-semibold text-xs sm:text-sm" data-id="element-103" data-mp="3g9z3zzwlihr0">Winx Club Coloring Book (50 diseños GRATIS)</span></span>
                </p>
              </div>
              <ul className="space-y-3" data-id="element-104" data-mp="3b8rwm1yd7kkv">
                {['La mejor relación cantidad/precio', 'Descarga inmediata', 'Imprimí sin límites'].map((feature, idx) => <li key={idx} className="flex items-start text-[#2D2D3F] font-medium text-sm sm:text-base" data-id="element-105" data-mp="3l0fno1r0ezlt" data-mpi={idx}>
                    <CheckIcon className="w-5 h-5 text-[#FF6B8A] mr-2 shrink-0 mt-0.5" data-id="element-106" data-mp="2vugrj79nbvy" />
                    <span data-id="element-107" data-mp="3u2f2qoigrtm4">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-auto text-center md:text-left" data-id="element-108" data-mp="hx1act92vci0">
              <div className="mb-4" data-id="element-109" data-mp="lzo4x1x4vbiw">
                <span className="text-gray-400 line-through text-sm sm:text-base block" data-id="element-110" data-mp="lymk45qbfanz">
                  {isAR ? '$59.990' : '$39.99'}
                </span>
                <span className="text-3xl sm:text-4xl font-extrabold text-[#FF6B8A]" data-id="element-111" data-mp="vphg41td5omm">
                  🔥 {isAR ? '$29.990 ARS' : '$14.99 USD'}
                </span>
              </div>

              <div className="mb-4 bg-[#FFF5F7] border border-[#FFD1D9] rounded-xl p-3 flex flex-col items-center justify-center shadow-sm" data-id="element-112" data-mp="3v6z0y07z1c4d">
                <span className="text-xs font-bold text-[#FF6B8A] uppercase tracking-wide mb-1" data-id="element-113" data-mp="7zn3nlcyi22w">
                  Esta oferta termina en:
                </span>
                <div className="flex items-center gap-1.5 font-mono font-bold text-xl text-[#2D2D3F]" data-id="element-114" data-mp="1jf226tktd204">
                  <ClockIcon className="w-5 h-5 text-[#FF6B8A]" data-id="element-115" data-mp="1oe689bcfyjm8" />
                  {formatTime(hours)}:{formatTime(minutes)}:
                  {formatTime(seconds)}
                </div>
              </div>

              <a href="https://disney-coloring.impultienda.ar/checkout/mega-pack-disney" className="block w-full py-3 sm:py-4 px-4 rounded-full font-bold bg-[#FF6B8A] text-white hover:bg-[#ff5275] shadow-lg transition-all text-base sm:text-lg text-center" data-id="element-116" data-mp="33xe00mavq1yf">
                QUIERO EL MEGA PACK
              </a>
              <p className="text-xs sm:text-sm text-[#6B7280] mt-4 text-center" data-id="element-117" data-mp="2q68wh94e4pit">
                El más elegido porque incluye toda la colección con el mejor
                valor.
              </p>
            </div>
          </motion.div>

          {/* Pack Básico (Mobile: Order 2, Desktop: Order 1) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="order-2 md:order-1 w-full md:w-1/3 bg-white rounded-3xl p-6 sm:p-8 shadow-md border border-gray-100 flex flex-col" data-id="element-118" data-mp="2b98dpv46g4wh">
            <div className="mb-4 flex justify-center" data-id="element-119" data-mp="28oiqa2a9lhzs">
              <img src="https://cdn.magicpatterns.com/uploads/8Nencbag8hzm7BBFiApiwb/PACK_BASE.png" alt="Pack Básico" className="w-full max-w-[160px] object-contain drop-shadow-md" data-id="element-120" data-mp="28pbryoud9hb2" />
            </div>
            <div className="mb-5 text-center md:text-left" data-id="element-121" data-mp="1yyh5bjd7kfp3">
              <h3 className="text-xl sm:text-2xl font-bold text-[#2D2D3F] mb-1" data-id="element-122" data-mp="2motj3av4x6nl">
                Pack Básico
              </h3>
              <p className="text-[#6B7280] text-sm sm:text-base" data-id="element-123" data-mp="2rm3gpdsogomi">
                4 colecciones de coloreables Disney
              </p>
            </div>
            <div className="mb-6 flex-grow" data-id="element-124" data-mp="2ho5s2p6woptd">
              <ul className="space-y-3" data-id="element-125" data-mp="2hmvs1ught7k3">
                {['4 colecciones', 'Descarga inmediata', 'Imprimí sin límites'].map((feature, idx) => <li key={idx} className="flex items-start text-[#2D2D3F] text-sm sm:text-base" data-id="element-126" data-mp="169jw05qz5t8h" data-mpi={idx}>
                    <CheckIcon className="w-5 h-5 text-[#9B8FE8] mr-2 shrink-0 mt-0.5" data-id="element-127" data-mp="yq0uojdv5db3" />
                    <span data-id="element-128" data-mp="yru3a481e7lq">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-auto text-center md:text-left" data-id="element-129" data-mp="ttafrzdsonr9">
              <div className="text-2xl sm:text-3xl font-bold text-[#2D2D3F] mb-4" data-id="element-130" data-mp="18mvtz4hynhqf">
                {isAR ? '$14.990 ARS' : '$7.99 USD'}
              </div>
              <a href="https://disney-coloring.impultienda.ar/checkout/pack-basico-disney" className="block w-full py-3 px-4 rounded-full font-bold border-2 border-[#9B8FE8] text-[#9B8FE8] hover:bg-[#9B8FE8] hover:text-white transition-colors text-sm sm:text-base text-center" data-id="element-131" data-mp="fz9otrt3451g">
                QUIERO EL PACK BÁSICO
              </a>
            </div>
          </motion.div>

          {/* Pack Familiar (Mobile: Order 3, Desktop: Order 2) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} className="order-3 md:order-2 w-full md:w-1/3 bg-white rounded-3xl p-6 sm:p-8 shadow-md border border-gray-100 flex flex-col" data-id="element-132" data-mp="3td4nmpd0pbsx">
            <div className="mb-4 flex justify-center" data-id="element-133" data-mp="3ct4lvuz95nhi">
              <img src="https://cdn.magicpatterns.com/uploads/7QAMdcjDiVzPaBotXieEb9/PACK_FAMILIAR.png" alt="Pack Familiar" className="w-full max-w-[180px] object-contain drop-shadow-md" data-id="element-134" data-mp="3gvsxgafcp8i6" />
            </div>
            <div className="mb-5 text-center md:text-left" data-id="element-135" data-mp="3qtyvggy1duhr">
              <h3 className="text-xl sm:text-2xl font-bold text-[#2D2D3F] mb-1" data-id="element-136" data-mp="3qs4c372eyafs">
                Pack Familiar
              </h3>
              <p className="text-[#6B7280] text-sm sm:text-base" data-id="element-137" data-mp="4ee8cmfiq4wq">
                7 colecciones completas
              </p>
            </div>
            <div className="mb-6 flex-grow" data-id="element-138" data-mp="8h0ty5llitlh">
              <ul className="space-y-3" data-id="element-139" data-mp="8e4ugcu3nwux">
                {['7 colecciones', 'Más variedad para elegir', 'Descarga inmediata', 'Imprimí sin límites'].map((feature, idx) => <li key={idx} className="flex items-start text-[#2D2D3F] text-sm sm:text-base" data-id="element-140" data-mp="1xy61dfntv0eo" data-mpi={idx}>
                    <CheckIcon className="w-5 h-5 text-[#9B8FE8] mr-2 shrink-0 mt-0.5" data-id="element-141" data-mp="1swytzhplk38j" />
                    <span data-id="element-142" data-mp="1ovn5jfiglo1x">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-auto text-center md:text-left" data-id="element-143" data-mp="1jy3rogpobdai">
              <div className="text-2xl sm:text-3xl font-bold text-[#2D2D3F] mb-4" data-id="element-144" data-mp="2gnl3ldf91vkn">
                {isAR ? '$19.990 ARS' : '$10.99 USD'}
              </div>
              <a href="https://disney-coloring.impultienda.ar/checkout/pack-familiar-disney" className="block w-full py-3 px-4 rounded-full font-bold border-2 border-[#9B8FE8] text-[#9B8FE8] hover:bg-[#9B8FE8] hover:text-white transition-colors text-sm sm:text-base text-center" data-id="element-145" data-mp="2cmj2ss5opbgk">
                QUIERO EL PACK FAMILIAR
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}